import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export interface DropdownMenuOption {
  id: string;
  label: string;
  icon: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-action-dropdown',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './action-dropdown.component.html',
  styleUrls: ['./action-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ActionDropdownComponent {
  @Input() label: string = 'More';
  @Input() options: DropdownMenuOption[] = [];
  @Input() disabled: boolean = false;
  @Output() optionSelected = new EventEmitter<DropdownMenuOption>();

  isOpen: boolean = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: HTMLElement): void {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.isOpen = false;
    }
  }

  toggle(): void {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  select(option: DropdownMenuOption): void {
    if (option.disabled) {
      return;
    }
    this.optionSelected.emit(option);
    this.isOpen = false;
  }
}
